import { getIdentityBaseUrl } from '@sitecore-ui/portal-singular';
import { AxiosInstance } from 'axios';
import { env } from '../config/envConfig';
import { UserRoleResponse } from './models/getUserRoles';

export const getUserRoles = async (
  axiosContext: AxiosInstance,
  organizationId: string,
) => {
  try {
    const roles = await axiosContext.get<UserRoleResponse>(
      `${getIdentityBaseUrl(env)}/user/roles?pagenumber=1&pagesize=100`,
    );

    return roles.data.data.filter(
      (role) => role.organizationId === organizationId,
    );
  } catch (error) {
    console.error('Error fetching user roles:', error);
  }
};
